import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPendingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.625 3h-1.25V8.26l3.125 3.125.884-.884-2.759-2.759z" />
        <path d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.25 8a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z" />
      </g>
    </svg>
  )
);
SvgActionsPendingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPendingNormalXsmall;
